import is from '@sindresorhus/is';
import { z } from 'zod';

import { entityIdentifierSchema, entityTypeSchema } from '~/shared/data-contract/chat/chat-entity';

export const richTextTextElementSchema = z.object({
    text: z.string(),
    type: z.literal('text'),
});

export type RichTextTextElement = z.infer<typeof richTextTextElementSchema>;

export const richTextMentionElementSchema = z.object({
    entity: entityIdentifierSchema,
    label: z.string().min(1),
    openInNewTab: z.boolean().optional(),
    type: z.literal('mention'),
});

export type RichTextMentionElement = z.infer<typeof richTextMentionElementSchema>;

// The backend can ship a mention entity type before this bundle knows it. Such a mention renders
// as its plain label (empty when it has none) instead of failing the whole text block.
const degradeUnknownMention = (input: unknown): unknown => {
    if (!is.plainObject(input) || input['type'] !== 'mention') return input;
    const entity = input['entity'];
    if (!is.plainObject(entity) || entityTypeSchema.safeParse(entity['type']).success) return input;
    return { text: is.string(input['label']) ? input['label'] : '', type: 'text' };
};

export const richTextElementSchema = z.preprocess(
    degradeUnknownMention,
    z.discriminatedUnion('type', [richTextTextElementSchema, richTextMentionElementSchema]),
);

export type RichTextElement = z.infer<typeof richTextElementSchema>;
